import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './floating-bar.styl'

export default class FloatingBar extends Component {
  static propTypes = {
    children: PropTypes.any.isRequired,
    notFixed: PropTypes.bool
  }

  render() {
    const { children, notFixed } = this.props
    const notFixedClass = notFixed ? styles.notFixed : ''

    return (
      <div className={`${styles.bar} ${notFixedClass}`}>
        {children}
      </div>
    )
  }
}
